import React from 'react';
const DEFAULT_MOBILE_WIDTH_BREAKPOINT = 768;
export const useIsMobile = (breakpoint = DEFAULT_MOBILE_WIDTH_BREAKPOINT) => {
    const [width, setWidth] = React.useState(window.innerWidth);
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    React.useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        };
    }, []);
    const isMobile = width <= breakpoint;
    return isMobile;
};
//# sourceMappingURL=useIsMobile.js.map